import { render, staticRenderFns } from "./SuccessRequest.vue?vue&type=template&id=0396e3f8&"
import script from "./SuccessRequest.vue?vue&type=script&lang=ts&"
export * from "./SuccessRequest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports